module.exports = __webpack_public_path__ + "img/ico_export_active.0618d80c.svg";